<template>
  <el-container v-title data-title="食堂周菜单" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>食堂管理</el-breadcrumb-item>
                <el-breadcrumb-item>食堂周菜单</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search()">查询</el-button>
                  <!-- <el-button type="success" @click="statsForNextWeek()">下周点餐统计</el-button> -->
                  <el-button type="success" @click="statForWeekDialogVisible = true">每周点餐统计</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-calendar v-model="selectedDate">
          <template v-slot:dateCell="{data}">
            <div style="margin:0; height:100%" :class="{'closed': data.day < nextNextMonday, 'notClosed': data.day >= nextNextMonday}" @click="openWeekMenuDialog">
              <p style="margin:0">{{ data.day.split('-').slice(1).join('月') }}日</p>
              <p style="margin:28px 0 0 0; text-align:right">{{ dateToGoodsQtyMap[data.day] }}</p>
            </div>
          </template>
        </el-calendar>
      </el-main>
      <!-- 弹窗页（菜单） -->
      <el-dialog
        :title="selectedDateString"
        :visible.sync="weekMenuDialogVisible"
        width="1373px"
        :before-close="handleClose"
        append-to-body>
        <el-row>
          <el-col :span="14">
            <el-tag>早餐</el-tag>
            <el-table :data="typeToMenuGoodsListMap.早餐" border style="width: 100%">
              <el-table-column prop="goodsName" label="名称" width="165">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsName" placeholder="请输入名称" @focus="saveInputCache(scope.row, 'goodsName')" @blur="modifyMenuDetail(scope.row, 'goodsName')" :disabled="nextNextMonday > selectedDateString"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="yuanOfGoodsPrice" label="售价" width="115">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="2" :controls="false" v-model="scope.row.yuanOfGoodsPrice" style="width: 75px" @focus="saveInputCache(scope.row, 'yuanOfGoodsPrice')" @blur="modifyMenuDetail(scope.row, 'yuanOfGoodsPrice')" :disabled="nextNextMonday > selectedDateString"></el-input-number> 元
                </template>
              </el-table-column>
              <el-table-column prop="defaultGoodsName" label="默认名称" width="115"></el-table-column>
              <el-table-column prop="defaultGoodsPrice" :formatter="yuanOfDefaultGoodsPriceFormatter" label="默认价格" width="77"></el-table-column>
              <el-table-column prop="qtyLimitTotal" label="总限量（0为不限）" width="96">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="0" :controls="false" v-model="scope.row.qtyLimitTotal" style="width: 75px" @focus="saveInputCache(scope.row, 'qtyLimitTotal')" @blur="modifyMenuDetail(scope.row, 'qtyLimitTotal')" :disabled="nextNextMonday > selectedDateString"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="fareLimit" label="每餐限量（0为不限）" width="96">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="0" :controls="false" v-model="scope.row.fareLimit" style="width: 75px" @focus="saveInputCache(scope.row, 'fareLimit')" @blur="modifyMenuDetail(scope.row, 'fareLimit')" :disabled="nextNextMonday > selectedDateString"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="requiredItem" label="是否必选" width="62">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.requiredItem" active-color="#13ce66" inactive-color="#777" @change="modifyMenuDetail(scope.row, 'requiredItem')" :disabled="nextNextMonday > selectedDateString"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="51">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteMenuDetail(scope.row)" v-if="selectedDateString >= nextNextMonday">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-tag>午餐</el-tag>
            <el-table :data="typeToMenuGoodsListMap.午餐" border style="width: 100%">
              <el-table-column prop="goodsName" label="名称" width="165">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsName" placeholder="请输入名称" @focus="saveInputCache(scope.row, 'goodsName')" @blur="modifyMenuDetail(scope.row, 'goodsName')" :disabled="nextNextMonday > selectedDateString"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="yuanOfGoodsPrice" label="售价"  width="115">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="2" :controls="false" v-model="scope.row.yuanOfGoodsPrice" style="width: 75px" @focus="saveInputCache(scope.row, 'yuanOfGoodsPrice')" @blur="modifyMenuDetail(scope.row, 'yuanOfGoodsPrice')" :disabled="nextNextMonday > selectedDateString"></el-input-number> 元
                </template>
              </el-table-column>
              <el-table-column prop="defaultGoodsName" label="默认名称" width="115"></el-table-column>
              <el-table-column prop="defaultGoodsPrice" :formatter="yuanOfDefaultGoodsPriceFormatter" label="默认价格" width="77"></el-table-column>
              <el-table-column prop="qtyLimitTotal" label="总限量（0为不限）" width="96">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="0" :controls="false" v-model="scope.row.qtyLimitTotal" style="width: 75px" @focus="saveInputCache(scope.row, 'qtyLimitTotal')" @blur="modifyMenuDetail(scope.row, 'qtyLimitTotal')" :disabled="nextNextMonday > selectedDateString"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="fareLimit" label="每餐限量（0为不限）" width="96">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="0" :controls="false" v-model="scope.row.fareLimit" style="width: 75px" @focus="saveInputCache(scope.row, 'fareLimit')" @blur="modifyMenuDetail(scope.row, 'fareLimit')" :disabled="nextNextMonday > selectedDateString"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="requiredItem" label="是否必选" width="62">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.requiredItem" active-color="#13ce66" inactive-color="#777" @change="modifyMenuDetail(scope.row, 'requiredItem')" :disabled="nextNextMonday > selectedDateString"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="51">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteMenuDetail(scope.row)" v-if="selectedDateString >= nextNextMonday">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-tag>晚餐</el-tag>
            <el-table :data="typeToMenuGoodsListMap.晚餐" border style="width: 100%">
              <el-table-column prop="goodsName" label="名称" width="165">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsName" placeholder="请输入名称" @focus="saveInputCache(scope.row, 'goodsName')" @blur="modifyMenuDetail(scope.row, 'goodsName')" :disabled="nextNextMonday > selectedDateString"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="yuanOfGoodsPrice" label="售价"  width="115">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="2" :controls="false" v-model="scope.row.yuanOfGoodsPrice" style="width: 75px" @focus="saveInputCache(scope.row, 'yuanOfGoodsPrice')" @blur="modifyMenuDetail(scope.row, 'yuanOfGoodsPrice')" :disabled="nextNextMonday > selectedDateString"></el-input-number> 元
                </template>
              </el-table-column>
              <el-table-column prop="defaultGoodsName" label="默认名称" width="115"></el-table-column>
              <el-table-column prop="defaultGoodsPrice" :formatter="yuanOfDefaultGoodsPriceFormatter" label="默认价格" width="77"></el-table-column>
              <el-table-column prop="qtyLimitTotal" label="总限量（0为不限）" width="96">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="0" :controls="false" v-model="scope.row.qtyLimitTotal" style="width: 75px" @focus="saveInputCache(scope.row, 'qtyLimitTotal')" @blur="modifyMenuDetail(scope.row, 'qtyLimitTotal')" :disabled="nextNextMonday > selectedDateString"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="fareLimit" label="每餐限量（0为不限）" width="96">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="0" :controls="false" v-model="scope.row.fareLimit" style="width: 75px" @focus="saveInputCache(scope.row, 'fareLimit')" @blur="modifyMenuDetail(scope.row, 'fareLimit')" :disabled="nextNextMonday > selectedDateString"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="requiredItem" label="是否必选" width="62">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.requiredItem" active-color="#13ce66" inactive-color="#777" @change="modifyMenuDetail(scope.row, 'requiredItem')" :disabled="nextNextMonday > selectedDateString"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="51">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteMenuDetail(scope.row)" v-if="selectedDateString >= nextNextMonday">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-tag>每周商品</el-tag>
            <el-table :data="typeToMenuGoodsListMap.每周商品" border style="width: 100%">
              <el-table-column prop="goodsName" label="名称" width="227">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsName" placeholder="请输入名称" @focus="saveInputCache(scope.row, 'goodsName')" @blur="modifyMenuDetail(scope.row, 'goodsName')" :disabled="nextNextMonday > selectedDateString"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="yuanOfGoodsPrice" label="售价"  width="115">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="2" :controls="false" v-model="scope.row.yuanOfGoodsPrice" style="width: 75px" @focus="saveInputCache(scope.row, 'yuanOfGoodsPrice')" @blur="modifyMenuDetail(scope.row, 'yuanOfGoodsPrice')" :disabled="nextNextMonday > selectedDateString"></el-input-number> 元
                </template>
              </el-table-column>
              <el-table-column prop="defaultGoodsName" label="默认名称" width="115"></el-table-column>
              <el-table-column prop="defaultGoodsPrice" :formatter="yuanOfDefaultGoodsPriceFormatter" label="默认价格" width="77"></el-table-column>
              <el-table-column prop="qtyLimitTotal" label="总限量（0为不限）" width="96">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="0" :controls="false" v-model="scope.row.qtyLimitTotal" style="width: 75px" @focus="saveInputCache(scope.row, 'qtyLimitTotal')" @blur="modifyMenuDetail(scope.row, 'qtyLimitTotal')" :disabled="nextNextMonday > selectedDateString"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="fareLimit" label="每餐限量（0为不限）" width="96">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="10000" :precision="0" :controls="false" v-model="scope.row.fareLimit" style="width: 75px" @focus="saveInputCache(scope.row, 'fareLimit')" @blur="modifyMenuDetail(scope.row, 'fareLimit')" :disabled="nextNextMonday > selectedDateString"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="51">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteMenuDetail(scope.row)" v-if="selectedDateString >= nextNextMonday">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="1">
            <p></p>
          </el-col>
          <el-col :span="9">
            <el-col :span="10"><el-tag>默认菜品</el-tag></el-col>
            <el-col :span="14"><el-input v-model="filterCuisineName" placeholder="菜品名称"></el-input></el-col>
            <el-table max-height="250" :data="typeToSchoolGoodsListMap.cuisine" border style="width: 100%">
              <el-table-column prop="name" label="名称"></el-table-column>
              <el-table-column prop="price" :formatter="yuanOfPriceFormatter" label="价格" width="70"></el-table-column>
              <el-table-column label="设置为" width="141">
                <template slot-scope="scope">
                  <el-button type="text" :disabled="typeToMenuGoodsListMap.早餐 == null || typeToMenuGoodsListMap.早餐 != null && typeToMenuGoodsListMap.早餐.map(item => item.goodsId).indexOf(scope.row.id) != -1" @click="addCuisine(scope.row, '1')"  v-if="selectedDateString >= nextNextMonday">早餐</el-button>
                  <el-button type="text" :disabled="typeToMenuGoodsListMap.午餐 == null || typeToMenuGoodsListMap.午餐 != null && typeToMenuGoodsListMap.午餐.map(item => item.goodsId).indexOf(scope.row.id) != -1" @click="addCuisine(scope.row, '2')"  v-if="selectedDateString >= nextNextMonday">午餐</el-button>
                  <el-button type="text" :disabled="typeToMenuGoodsListMap.晚餐 == null || typeToMenuGoodsListMap.晚餐 != null && typeToMenuGoodsListMap.晚餐.map(item => item.goodsId).indexOf(scope.row.id) != -1" @click="addCuisine(scope.row, '3')"  v-if="selectedDateString >= nextNextMonday">晚餐</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="10"><el-tag>默认商品</el-tag></el-col>
            <el-col :span="14"><el-input v-model="filterGoodsName" placeholder="商品名称"></el-input></el-col>
            <el-table max-height="250" :data="typeToSchoolGoodsListMap.goods" border style="width: 100%">
              <el-table-column prop="name" label="名称"></el-table-column>
              <el-table-column prop="price" :formatter="yuanOfPriceFormatter" label="价格"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" :disabled="typeToMenuGoodsListMap.每周商品 == null || typeToMenuGoodsListMap.每周商品 != null && typeToMenuGoodsListMap.每周商品.map(item => item.goodsId).indexOf(scope.row.id) != -1" @click="addGoods(scope.row)"  v-if="selectedDateString >= nextNextMonday">添加到每周商品</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" style="height: 1px"></el-col>
          <el-col :span="12">
            <el-tag>统计（含预定中、预定成功、已完成、已退款，不含已取消）</el-tag>
            <el-table max-height="250" :data="statsList" border style="width: 100%">
              <el-table-column prop="partOfDayName" label="时段"></el-table-column>
              <el-table-column prop="goodsName" label="名称"></el-table-column>
              <el-table-column prop="goodsTypeName" label="类型" width="80"></el-table-column>
              <el-table-column prop="qty" label="份数" width="80"></el-table-column>
              <el-table-column prop="goodsPrice" :formatter="yuanOfGoodsPriceFormatter" label="单价" width="80"></el-table-column>
              <el-table-column prop="detailAmount" :formatter="yuanOfDetailAmountFormatter" label="总价" width="80"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 弹窗页（按周统计） -->
      <el-dialog
        title="按周统计"
        :visible.sync="statForWeekDialogVisible"
        width="1200px" :before-close="handleClose" append-to-body>
        <el-form :inline="true">
          <el-form-item label="选择周">
            <el-date-picker
              v-model="weekFirstDay"
              type="week"
              format="yyyy 年第 WW 周"
              placeholder="选择周"
              :picker-options="{'firstDayOfWeek': 1}">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="statsForWeek()">查询</el-button>
          </el-form-item>
        </el-form>
        <el-row v-if="statResultVisible">
          <el-row>
            <el-col :span="3" class="grid-content">时段\日期</el-col>
            <el-col :span="3" class="grid-content">{{ statForNextWeekData.topTitleArray[0] }}</el-col>
            <el-col :span="3" class="grid-content">{{ statForNextWeekData.topTitleArray[1] }}</el-col>
            <el-col :span="3" class="grid-content">{{ statForNextWeekData.topTitleArray[2] }}</el-col>
            <el-col :span="3" class="grid-content">{{ statForNextWeekData.topTitleArray[3] }}</el-col>
            <el-col :span="3" class="grid-content">{{ statForNextWeekData.topTitleArray[4] }}</el-col>
            <el-col :span="3" class="grid-content">{{ statForNextWeekData.topTitleArray[5] }}</el-col>
            <el-col :span="3" class="grid-content">{{ statForNextWeekData.topTitleArray[6] }}</el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="3" class="grid-content">早餐</el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[0]].早餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[1]].早餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[2]].早餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[3]].早餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[4]].早餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[5]].早餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[6]].早餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="3" class="grid-content">午餐</el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[0]].午餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[1]].午餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[2]].午餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[3]].午餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[4]].午餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[5]].午餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[6]].午餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="3" class="grid-content">晚餐</el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[0]].晚餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[1]].晚餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[2]].晚餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[3]].晚餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[4]].晚餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[5]].晚餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
            <el-col :span="3" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.cuisine[statForNextWeekData.topTitleArray[6]].晚餐"
                :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="3" class="grid-content">每周商品</el-col>
            <el-col :span="21" class="grid-content">
              <div v-for="(value, key, index) in statForNextWeekData.goods" :key="index">
                {{ key }}：{{ value.quantity }}份/{{ value.price }}元
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          未点餐名单：{{ statForNextWeekData.unreservedRealNames }}
          <el-divider></el-divider>
          <el-button style="margin-left: 10px;" type="primary" @click="downloadStats">下载</el-button>
        </el-row>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      loading: false,
      searchForm: {
        schoolId: null
      },
      weekMenuData: {},
      weekMenuDialogVisible: false,
      selectedDate: new Date(),
      nextNextMonday: null,
      nextNextSunday: null,
      typeToMenuGoodsListMap: [],
      typeToSchoolGoodsListMap: [],
      inputCache: {},
      dateToGoodsQtyMap: {},
      statsList: [],
      filterCuisineName: '',
      filterGoodsName: '',
      statForNextWeekDialogVisible: false,
      statForNextWeekData: {
        topTitleArray: [],
        lineHeight: {
          '早餐': 25,
          '午餐': 25,
          '晚餐': 25,
          '每日商品': 25
        },
        cuisine: {},
        goods: {}
      },
      weekFirstDay: '',
      statForWeekDialogVisible: false,
      statResultVisible: false
    }
  },
  created () {
    let now = Math.round(new Date().getTime() / 1000)
    if (this.Cookie.get('offsetSecond') !== undefined || this.Cookie.get('offsetSecond') !== '') {
      now += parseInt(this.Cookie.get('offsetSecond'))
      let calcMonday = new Date(now * 1000)
      let day = calcMonday.getDay() || 7
      if (day !== 1) {
        calcMonday.setHours(-24 * (day - 1))
      }
      calcMonday.setHours(8)
      this.weekFirstDay = calcMonday.toISOString().slice(0, 10)
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
      this.getDateRange()
    }
  },
  methods: {
    search () {
      this.getTypeToSchoolGoodsListMap()
      this.getDateToGoodsQtyMap()
    },
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      this.getDateToGoodsQtyMap()
      done()
    },
    changeGridStyle () {
      let closedDomList = document.querySelectorAll('.closed')
      for (let dom of closedDomList) {
        if (dom.parentNode.parentNode.className.includes('current')) {
          dom.parentNode.parentNode.style.backgroundColor = dom.parentNode.parentNode.className.includes('is-today') ? '#FFC964' : '#FFE4B5'
          dom.parentNode.parentNode.style.opacity = '1'
          dom.parentNode.parentNode.style.color = '#000'
        } else {
          dom.parentNode.parentNode.style.backgroundColor = '#FFE4B5'
          dom.parentNode.parentNode.style.opacity = '0.5'
          dom.parentNode.parentNode.style.color = '#000'
        }
      }
      let notClosedDomList = document.querySelectorAll('.notClosed')
      for (let dom of notClosedDomList) {
        if (dom.parentNode.parentNode.className.includes('current')) {
          dom.parentNode.parentNode.style.backgroundColor = '#90EE90'
          dom.parentNode.parentNode.style.opacity = '1'
          dom.parentNode.parentNode.style.color = '#000'
        } else {
          dom.parentNode.parentNode.style.backgroundColor = '#90EE90'
          dom.parentNode.parentNode.style.opacity = '0.5'
          dom.parentNode.parentNode.style.color = '#000'
        }
      }
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          filterCanteen: '1'
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getTypeToSchoolGoodsListMap()
              _this.getDateToGoodsQtyMap()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getDateRange () {
      let _this = this
      _this.loading = true
      this.$axios.get(this.GLOBAL.host + '/canteenWeekMenu/getDateRangeForMenu').then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.selectedDate = res.data.data.today
            _this.nextNextMonday = res.data.data.nextNextMonday
            _this.nextNextSunday = res.data.data.nextNextSunday
            setTimeout(() => {
              _this.changeGridStyle()
            }, 10)
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getDateToGoodsQtyMap () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/canteenWeekMenu/getDateToGoodsQtyMap',
        this.$qs.stringify({ schoolId: _this.searchForm.schoolId })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.dateToGoodsQtyMap = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getTypeToMenuGoodsListMap () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/canteenWeekMenu/getTypeToGoodsListMap',
        this.$qs.stringify({ schoolId: _this.searchForm.schoolId, date: _this.selectedDate.toISOString().split('T')[0] })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.typeToMenuGoodsListMap = res.data.data
            Object.keys(_this.typeToMenuGoodsListMap).forEach(function (key) {
              _this.typeToMenuGoodsListMap[key].forEach(element => {
                if (element.goodsPrice != null && element.goodsPrice > 0) {
                  element.yuanOfGoodsPrice = element.goodsPrice / 100
                }
                element.requiredItem = element.requiredItem != null && element.requiredItem === '1'
              })
            })
            _this.weekMenuDialogVisible = true
          }
        }
      })
    },
    getTypeToSchoolGoodsListMap () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/canteenGoods/getTypeToGoodsListMap',
        this.$qs.stringify({ schoolId: _this.searchForm.schoolId })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.typeToSchoolGoodsListMap = res.data.data
            if (_this.typeToSchoolGoodsListMap.菜品 != null) {
              _this.typeToSchoolGoodsListMap.cuisine = _this.typeToSchoolGoodsListMap.菜品
            }
            if (_this.typeToSchoolGoodsListMap.商品 != null) {
              _this.typeToSchoolGoodsListMap.goods = _this.typeToSchoolGoodsListMap.商品
            }
          }
        }
      })
    },
    getStats () {
      let _this = this
      this.statsList = []
      this.$axios.post(this.GLOBAL.host + '/canteenOrderDetail/stats',
        this.$qs.stringify({ schoolId: _this.searchForm.schoolId, date: _this.selectedDate })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.statsList = res.data.data
          }
        }
      })
    },
    openWeekMenuDialog () {
      let _this = this
      setTimeout(() => {
        _this.getTypeToMenuGoodsListMap()
        _this.getStats()
      }, 10)
    },
    yuanOfGoodsPriceFormatter (row) {
      return this.fenToyuanFormat(row.goodsPrice)
    },
    yuanOfDefaultGoodsPriceFormatter (row) {
      return this.fenToyuanFormat(row.defaultGoodsPrice)
    },
    yuanOfPriceFormatter (row) {
      return this.fenToyuanFormat(row.price)
    },
    yuanOfDetailAmountFormatter (row) {
      return this.fenToyuanFormat(row.detailAmount)
    },
    fenToyuanFormat (fen) {
      let yuan = ''
      if (fen !== 0) {
        yuan = fen / 100 + '元'
      }
      return yuan
    },
    saveInputCache (menuDetail, propName) {
      if (this.inputCache[menuDetail.id] == null) {
        this.inputCache[menuDetail.id] = {}
      }
      this.inputCache[menuDetail.id][propName] = menuDetail[propName]
    },
    addCuisine (schoolGoods, partOfDay) {
      let _this = this
      _this.weekMenuData.schoolId = _this.searchForm.schoolId
      _this.weekMenuData.goodsId = schoolGoods.id
      _this.weekMenuData.menuDate = _this.selectedDate

      console.log('=========test==========')
      console.log(_this.selectedDate)

      _this.weekMenuData.partOfDay = partOfDay
      this.$axios.post(this.GLOBAL.host + '/canteen/weekMenuDetail/addCuisine',
        _this.weekMenuData
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.getTypeToMenuGoodsListMap()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    addGoods (schoolGoods) {
      let _this = this
      _this.weekMenuData.schoolId = _this.searchForm.schoolId
      _this.weekMenuData.goodsId = schoolGoods.id
      _this.weekMenuData.menuDate = _this.selectedDate
      this.$axios.post(this.GLOBAL.host + '/canteen/weekMenuDetail/addGoods',
        _this.weekMenuData
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.getTypeToMenuGoodsListMap()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    modifyMenuDetail (menuDetail, propName) {
      let modifyData = {
        id: menuDetail.id
      }
      if (propName === 'goodsName') {
        if (menuDetail[propName] === '' || menuDetail[propName] === this.inputCache[menuDetail.id][propName]) {
          menuDetail[propName] = this.inputCache[menuDetail.id][propName]
          return
        }
        modifyData.goodsName = menuDetail.goodsName
      } else if (propName === 'yuanOfGoodsPrice') {
        if (menuDetail.yuanOfGoodsPrice <= 0 || !menuDetail[propName] || menuDetail[propName] === this.inputCache[menuDetail.id][propName]) {
          menuDetail[propName] = this.inputCache[menuDetail.id][propName]
          return
        }
        modifyData.goodsPrice = (menuDetail.yuanOfGoodsPrice * 100).toFixed(0)
      } else if (propName === 'qtyLimitTotal') {
        if (menuDetail.qtyLimitTotal < 0 || menuDetail[propName] === this.inputCache[menuDetail.id][propName]) {
          menuDetail[propName] = this.inputCache[menuDetail.id][propName]
          return
        }
        if (!menuDetail[propName]) menuDetail[propName] = 0
        modifyData.qtyLimitTotal = menuDetail.qtyLimitTotal
      } else if (propName === 'fareLimit') {
        if (menuDetail.fareLimit < 0 || menuDetail[propName] === this.inputCache[menuDetail.id][propName]) {
          menuDetail[propName] = this.inputCache[menuDetail.id][propName]
          return
        }
        if (!menuDetail[propName]) menuDetail[propName] = 0
        modifyData.fareLimit = menuDetail.fareLimit
      } else if (propName === 'requiredItem') {
        modifyData.requiredItem = menuDetail[propName] ? '1' : '0'
      }
      this.$axios.post(this.GLOBAL.host + '/canteen/weekMenuDetail/modify',
        this.$qs.stringify(modifyData)
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            this.$message({
              type: 'success',
              message: res.data.message
            })
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    deleteMenuDetail (menuDetail) {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/canteen/weekMenuDetail/delete',
        this.$qs.stringify({id: menuDetail.id})
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            this.$message({
              type: 'success',
              message: res.data.message
            })
            _this.getTypeToMenuGoodsListMap()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    statsForWeek () {
      let _this = this
      this.statsList = []
      this.$axios.post(this.GLOBAL.host + '/canteenOrderDetail/statsForWeek',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          firstDayStr: _this.weekFirstDay
        })
      ).then(res => {
        _this.statResultVisible = false
        if (res.data != null) {
          if (res.data.status === 200) {
            if (res.data.data != null) {
              _this.statResultVisible = true
              _this.statForNextWeekData = {
                topTitleArray: [],
                lineHeight: {
                  '早餐': 25,
                  '午餐': 25,
                  '晚餐': 25,
                  '每日商品': 25
                },
                cuisine: {},
                goods: {}
              }
              if (res.data.data.cuisine != null) {
                Object.keys(res.data.data.cuisine).forEach((key) => {
                  _this.statForNextWeekData.topTitleArray.push(key)
                  if (Object.keys(res.data.data.cuisine[key].早餐).length * 25 > _this.statForNextWeekData.lineHeight.早餐) {
                    _this.statForNextWeekData.lineHeight.早餐 = Object.keys(res.data.data.cuisine[key].早餐).length * 25
                  }
                  if (Object.keys(res.data.data.cuisine[key].午餐).length * 25 > _this.statForNextWeekData.lineHeight.午餐) {
                    _this.statForNextWeekData.lineHeight.午餐 = Object.keys(res.data.data.cuisine[key].午餐).length * 25
                  }
                  if (Object.keys(res.data.data.cuisine[key].晚餐).length * 25 > _this.statForNextWeekData.lineHeight.晚餐) {
                    _this.statForNextWeekData.lineHeight.晚餐 = Object.keys(res.data.data.cuisine[key].晚餐).length * 25
                  }
                })
                _this.statForNextWeekData.cuisine = res.data.data.cuisine
              }
              if (res.data.data.goods != null) {
                if (Object.keys(res.data.data.goods).length * 25 > _this.statForNextWeekData.lineHeight.每周商品) {
                  _this.statForNextWeekData.lineHeight.每周商品 = Object.keys(res.data.data.goods).length * 25
                }
                _this.statForNextWeekData.goods = res.data.data.goods
              }
              _this.statForNextWeekData.unreservedRealNames = res.data.data.unreservedRealNames
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    downloadStats () {
      if (this.searchForm.schoolId === '' || this.weekFirstDay === '') return
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/canteenOrderDetail/downloadStatsForWeek', this.$qs.stringify({
        schoolId: _this.searchForm.schoolId,
        firstDayStr: _this.weekFirstDay
      }), {
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                // console.log('errorMessage-111111')
                // console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              // console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
      })
    }
  },
  computed: {
    selectedDateString () {
      if (typeof this.selectedDate === 'string') {
        return this.selectedDate
      } else {
        return this.selectedDate.toISOString().substring(0, 10)
      }
    }
  },
  watch: {
    selectedDate () {
      setTimeout(() => {
        this.changeGridStyle()
      }, 10)
    },
    filterCuisineName () {
      if (this.filterCuisineName.length === 0) {
        this.typeToSchoolGoodsListMap.cuisine = this.typeToSchoolGoodsListMap.菜品
      } else {
        this.typeToSchoolGoodsListMap.cuisine = []
        this.typeToSchoolGoodsListMap.菜品.forEach(element => {
          if (element.name != null && element.name.includes(this.filterCuisineName)) {
            this.typeToSchoolGoodsListMap.cuisine.push(element)
          }
        })
      }
    },
    filterGoodsName () {
      if (this.filterGoodsName.length === 0) {
        this.typeToSchoolGoodsListMap.goods = this.typeToSchoolGoodsListMap.商品
      } else {
        this.typeToSchoolGoodsListMap.goods = []
        this.typeToSchoolGoodsListMap.商品.forEach(element => {
          if (element.name != null && element.name.includes(this.filterGoodsName)) {
            this.typeToSchoolGoodsListMap.goods.push(element)
          }
        })
      }
    }
  }
})
</script>
<style>
  .el-calendar-table td.current :hover {
    color: #FFF;
    background-color: #06a5f9;
  }
  .grid-content {
    min-height: 25px;
    line-height: 25px;
    padding: 2px;
    text-align: center;
  }
  .el-divider--horizontal {
    margin: 5px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/CanteenWeekMenu.vue